// Deterministic "data reliability" score based on how many inputs the user
// filled in. More detail -> higher score -> more precise estimate.
const num = (v) => Number(v) > 0;

export const computeDataCompleteness = (input) => {
  if (!input) return { score: 0, level: "low" };
  let score = 0;

  // Prices (both known is the strongest anchor)
  if (num(input.purchase_price) && num(input.original_retail_price)) score += 18;
  else if (num(input.purchase_price) || num(input.original_retail_price)) score += 10;

  // Identification
  if (input.brand) score += 8;
  if (input.model) score += 10;

  // Age / history
  if (num(input.age_months)) score += 8;

  // Photos enable AI vision analysis (strong signal)
  const photos = Array.isArray(input.photos) ? input.photos.length : 0;
  score += Math.min(photos, 3) * 8;

  // Description
  if (input.description && input.description.trim().length >= 20) score += 10;

  // Condition & authenticity extras
  ["has_box", "has_accessories", "has_warranty", "has_certificate", "has_verifiable_serial"]
    .forEach((k) => { if (input[k]) score += 2; });
  if (input.rarity) score += 4;
  if (input.seasonality) score += 2;
  if (input.material) score += 4;
  if (num(input.storage_gb)) score += 3;
  if (input.item_size) score += 3;
  if (num(input.usage_hours)) score += 4;

  // Vehicle-specific detail
  if (num(input.kilometers)) score += 6;
  ["service_history", "body_condition", "interior_condition", "euro_class", "fuel_type"]
    .forEach((k) => { if (input[k]) score += 2; });
  if (num(input.power_kw)) score += 2;
  if (num(input.owners_count)) score += 2;

  score = Math.min(100, Math.round(score));
  const level = score >= 70 ? "high" : score >= 40 ? "medium" : "low";
  return { score, level };
};
